import { GET_SINGLE_TERMS_AND_PRIVACY, GET_TERMS_AND_PRIVACY, SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE, START_LOADER, STOP_LOADER } from "./types";
import termsandprivacyService from "../services/termsandprivacy.service";
export const getTermsAndPrivacy = (type) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return termsandprivacyService.getTermsAndPrivacy(type).then((resp) => {
    if (resp.status) {
      if (type) {
        dispatch({ type: GET_SINGLE_TERMS_AND_PRIVACY, payload: resp.data, });
        dispatch({ type: GET_TERMS_AND_PRIVACY, payload: [] });
      } else {
        dispatch({ type: GET_SINGLE_TERMS_AND_PRIVACY, payload: {}, });
        dispatch({ type: GET_TERMS_AND_PRIVACY, payload: resp.data, });
      }
    } else {
      dispatch({ type: GET_SINGLE_TERMS_AND_PRIVACY, payload: {}, });
      dispatch({ type: GET_TERMS_AND_PRIVACY, payload: [] });
    }
    dispatch({ type: STOP_LOADER });
  });
};

export const addTermsAndPrivacy = (payload) => async (dispatch) => {
  dispatch({ type: START_LOADER });
  return termsandprivacyService.addTermsAndPrivacy(payload).then(async (resp) => {
    if (resp.status) {
      await dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.data });
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};
